export const NAV = [
  { title: 'Collections', href: '/collections' },
  { title: 'Process', href: '/process' },
  { title: 'About', href: '/about' },
];
// Hidden from nav in v22 (pages kept): Case Studies /case-studies, Ideas /ideas.
// Header button label. The destination stays /request-a-quote.
export const QUOTE = { title: 'Connect', href: '/request-a-quote' };
// Label used on in-page CTAs (hero, section buttons, footer CTA text).
export const QUOTE_CTA = { title: 'Start a Conversation', href: '/request-a-quote' };

export const SOCIAL = {
  instagramUrl: 'https://www.instagram.com/gforcepromo/',
  linkedinUrl: 'https://www.linkedin.com/company/gforce-promo',
};

export const CONTACT = {
  name: 'Gail Fox, Founder',
  phone: '516-983-4963',
  tel: '+15169834963',
  email: 'gfox@gforcepromo.com',
  town: 'Port Washington, NY',
};
